import { StarsButton } from '@ps/web-shared-components';
import React, { useEffect } from 'react';

import useTimer from '@swf/core/hooks/useTimer';

import { TXTMOB_Resend_code_in_N0 } from './ResendButton.messages.json';

interface Props {
  countdown: number;
  setCountdown: (time: number) => void;
}

const modifier = (s: number) => s - 1;

const ResendButton: React.FC<Props> = ({ countdown: initial, setCountdown }) => {
  const timer = useTimer({ modifier, initial });

  useEffect(() => {
    if (timer < 0) {
      setCountdown(0);
    }
  }, [setCountdown, timer]);

  return (
    <StarsButton
      variant="secondary"
      translation={TXTMOB_Resend_code_in_N0}
      values={{ 0: `00:00:${timer}` }}
      disabled
    />
  );
};

export default ResendButton;
